export const getInitialCooldown = (storageKey: string): number => {
  const storedUntil = localStorage.getItem(storageKey);
  if (!storedUntil) return 0;
  const remaining = Math.ceil((Number(storedUntil) - Date.now()) / 1000);
  return Math.max(remaining, 0);
};

export const getInitialCooldownOnReload = (storageKey: string): number => {
  const navEntry = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming | undefined;
  if (navEntry?.type === "reload") {
    return getInitialCooldown(storageKey);
  }
  localStorage.removeItem(storageKey);
  return 0;
};
